const ApiErrorMessage = ({ errors, showLabel = true, className }) => {
  // console.log(errors)
  let tmpErrors = errors;
  errors = null;
  const supportUrl =
    (tmpErrors && tmpErrors.support_url) ||
    (tmpErrors && tmpErrors.data && tmpErrors.data.support_url) ||
    (tmpErrors &&
      tmpErrors.response &&
      tmpErrors.response.data &&
      tmpErrors.response.data.support_url);
  if (typeof tmpErrors.response !== "undefined") {
    if (typeof tmpErrors.response.data !== "undefined") {
      if (typeof tmpErrors.response.data.errors !== "undefined") {
        errors = tmpErrors.response.data.errors;
      } else {
        errors = tmpErrors.response.data;
      }
    } else {
      if (typeof tmpErrors.response.errors !== "undefined") {
        errors = tmpErrors.response.errors;
      } else {
        errors = tmpErrors.response;
      }
    }
  } else if (typeof tmpErrors.data !== "undefined") {
    if (typeof tmpErrors.data.errors !== "undefined") {
      errors = tmpErrors.data.errors;
    } else {
      errors = tmpErrors.data;
    }
  } else if (typeof tmpErrors.errors !== "undefined") {
    errors = tmpErrors.errors;
  } else if (typeof tmpErrors.error !== "undefined") {
    errors = tmpErrors.error;
  } else if (typeof tmpErrors.message !== "undefined") {
    errors = tmpErrors.message;
  } else if (typeof tmpErrors.e !== "undefined") {
    errors = tmpErrors.e;
  } else if (tmpErrors) {
    errors = tmpErrors;
  } else {
    errors = "There was an error";
  }

  className =
    "apiError-wrap form-error mt-0" + (className ? " " + className : "");
  return (
    <div className={className}>
      {typeof errors === "object" && (
        <List errors={errors} supportUrl={supportUrl} />
      )}
      {typeof errors === "string" && (
        <span>
          {errors}
          {supportUrl && (
            <>
              {" "}
              <a
                href={supportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-underline text-white ms-1"
              >
                Click here
              </a>
            </>
          )}
        </span>
      )}
    </div>
  );
};

const List = ({ errors, supportUrl }) => (
  <ul className="apiError-list">
    {Object.keys(errors).map(function (k) {
      const val = errors[k];
      if (Array.isArray(val)) {
        return val.map((msg, i) => (
          <li key={`${k}-${i}`} className="apiError-listItem">
            {msg}
            {supportUrl && (
              <>
                {" "}
                <a
                  href={supportUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-underline text-white ms-1"
                >
                  Click here
                </a>
              </>
            )}
          </li>
        ));
      }
      return (
        <li key={k} className="apiError-listItem">
          {val}
          {supportUrl && (
            <>
              {" "}
              <a
                href={supportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-underline text-white ms-1"
              >
                Click here
              </a>
            </>
          )}
        </li>
      );
    })}
  </ul>
);

export default ApiErrorMessage;
